// Auto-generated from button.json
export default {
  "tagName": "ui-buttons",
  "types": [
    "vertical"
  ],
  "variations": [
    "attached",
    "color",
    "compact",
    "floated",
    "size",
    "inverted",
    "separate",
    "equal-width"
  ],
  "attributes": [
    "attached",
    "color",
    "compact",
    "floated",
    "size",
    "inverted",
    "vertical",
    "separate",
    "equal-width"
  ],
  "optionAttributes": {
    "top-attached": "attached",
    "attached": "attached",
    "bottom-attached": "attached",
    "left-attached": "attached",
    "right-attached": "attached",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "black": "color",
    "compact": "compact",
    "very-compact": "compact",
    "left-floated": "floated",
    "right-floated": "floated",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "two": "equal-width",
    "three": "equal-width",
    "four": "equal-width",
    "five": "equal-width",
    "six": "equal-width"
  },
  "propertyTypes": {
    "attached": "string",
    "color": "string",
    "compact": "string",
    "floated": "string",
    "size": "string",
    "inverted": "boolean",
    "vertical": "boolean",
    "separate": "boolean",
    "equal-width": "string"
  },
  "allowedValues": {
    "attached": [
      "top-attached",
      "attached",
      "bottom-attached",
      "left-attached",
      "right-attached"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "black"
    ],
    "compact": [
      "compact",
      "very-compact"
    ],
    "floated": [
      "left-floated",
      "right-floated"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ],
    "equal-width": [
      "two",
      "three",
      "four",
      "five",
      "six"
    ]
  },
  "attributeClasses": [
    "attached"
  ],
  "inheritedPluralVariations": [
    "inverted",
    "size",
    "floated",
    "compact",
    "color",
    "attached"
  ]
};
